/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export default {
    METHOD_GUEST: 'guest',
    METHOD_REGISTER: 'register',
    METHOD_CUSTOMER: 'customer',
    SET_QUOTE: '[QUOTE] SET_QUOTE',
    ADD_PRODUCT: '[QUOTE] ADD_PRODUCT',
    ADD_PRODUCT_AFTER: '[QUOTE] ADD_PRODUCT_AFTER',
    ADD_PRODUCT_SUCCESS: '[QUOTE] ADD_PRODUCT_SUCCESS',
    ADD_PRODUCT_FAIL: '[QUOTE] ADD_PRODUCT_FAIL',
    REMOVE_CART: '[QUOTE] REMOVE_CART',
    REMOVE_CART_ITEM: '[QUOTE] REMOVE_CART_ITEM',
    REMOVE_CART_ITEM_AFTER: '[QUOTE] REMOVE_CART_ITEM_AFTER',
    REMOVE_CART_ITEM_SUCCESS: '[QUOTE] REMOVE_CART_ITEM_SUCCESS',
    REMOVE_CART_ITEM_FAIL: '[QUOTE] REMOVE_CART_ITEM_FAIL',
    UPDATE_QTY_CART_ITEM: '[QUOTE] UPDATE_QTY_CART_ITEM',
    UPDATE_QTY_CART_ITEM_AFTER: '[QUOTE] UPDATE_QTY_CART_ITEM_AFTER',
    UPDATE_QTY_CART_ITEM_SUCCESS: '[QUOTE] UPDATE_QTY_CART_ITEM_SUCCESS',
    UPDATE_QTY_CART_ITEM_FAIL: '[QUOTE] UPDATE_QTY_CART_ITEM_FAIL',
    SET_PAYMENTS: '[QUOTE] SET_PAYMENTS',
    REMOVE_PAYMENT: '[QUOTE] REMOVE_PAYMENT',
    ADD_PAYMENT: '[QUOTE] ADD_PAYMENT',
    SET_CUSTOMER: '[QUOTE] SET_CUSTOMER',
    CHANGE_CUSTOMER_AFTER: '[QUOTE] CHANGE_CUSTOMER_AFTER',
    ADD_COUPON_CODE_AFTER: '[QUOTE] ADD_COUPON_CODE_AFTER',
    REMOVE_COUPON_CODE: '[QUOTE] REMOVE_COUPON_CODE',
    VALIDATE_QUOTE_SALES_RULE: '[QUOTE] VALIDATE_QUOTE_SALES_RULE',
    PRODUCT_ADD_QUOTE: '[QUOTE] PRODUCT_ADD_QUOTE',
    PRODUCT_UPDATED_QUOTE: '[QUOTE] PRODUCT_UPDATED_QUOTE',
    PLACE_ORDER_BEFORE: '[QUOTE] PLACE_ORDER_BEFORE',
    UPDATE_CUSTOM_PRICE_CART_ITEM: '[QUOTE] UPDATE_CUSTOM_PRICE_CART_ITEM',
    UPDATE_CUSTOM_PRICE_CART_ITEM_FAIL: '[QUOTE] UPDATE_CUSTOM_PRICE_CART_ITEM_FAIL',
    SET_CUSTOM_DISCOUNT: '[QUOTE] SET_CUSTOM_DISCOUNT',
    REMOVE_CUSTOM_DISCOUNT: '[QUOTE] REMOVE_CUSTOM_DISCOUNT',
}



// WEBPACK FOOTER //
// ./src/view/constant/checkout/QuoteConstant.js